import {
  faArrowLeft,
  faArrowRight,
  faArrowToLeft,
  faArrowToRight,
  faEllipsis
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { Fragment } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import {
  StyledButtonLink,
  StyledEllipsis,
  StyledPagination
} from './BlogPagination.styled';
import { SUCCESS_STORIES_BLOG_CATEGORY_SLUG } from '../constants';

type BlogPaginationProps = {
  totalPosts?: number;
  totalPages?: number;
  currentPage?: number;
  category?: string;
};

const ellipsis = (
  <StyledEllipsis>
    <FontAwesomeIcon icon={faEllipsis} />
  </StyledEllipsis>
);

const BlogPagination: React.FC<BlogPaginationProps> = ({
  totalPages,
  currentPage,
  category = SUCCESS_STORIES_BLOG_CATEGORY_SLUG
}) => {
  const { locale } = useRouter();

  const pages = totalPages || 0;
  const page = currentPage || 1;
  const pagerPrefix = `${getAppUrl(APP_URLS.successStories, locale)}/page/`;

  return (
    <StyledPagination>
      {pages > 1 && page > 1 && (
        <>
          <Link href={`${pagerPrefix}1`} passHref>
            <StyledButtonLink sizes="sm" variant="secondary" isIcon>
              <FontAwesomeIcon icon={faArrowToLeft} />
            </StyledButtonLink>
          </Link>

          <Link href={`${pagerPrefix}${page - 1}`} passHref>
            <StyledButtonLink sizes="sm" variant="secondary" isIcon>
              <FontAwesomeIcon icon={faArrowLeft} />
            </StyledButtonLink>
          </Link>
        </>
      )}

      {page - 2 > 0 && ellipsis}

      {[...Array(pages)].map((p, i) => (
        <Fragment key={`${pagerPrefix}${i + 1}`}>
          {i + 1 >= page - 1 && i + 1 <= page + 1 && (
            <Link href={`${pagerPrefix}${i + 1}`} passHref>
              <StyledButtonLink
                sizes="sm"
                variant="secondary"
                isIcon
                className="number"
                $isActive={page === i + 1}
              >
                <span>{String(i + 1).padStart(2, '0')}</span>
              </StyledButtonLink>
            </Link>
          )}
        </Fragment>
      ))}

      {page + 2 <= pages && ellipsis}

      {pages > 1 && page < pages && (
        <>
          <Link href={`${pagerPrefix}${page + 1}`} passHref>
            <StyledButtonLink sizes="sm" variant="secondary" isIcon>
              <FontAwesomeIcon icon={faArrowRight} />
            </StyledButtonLink>
          </Link>
          <Link href={`${pagerPrefix}${pages}`} passHref>
            <StyledButtonLink sizes="sm" variant="secondary" isIcon>
              <FontAwesomeIcon icon={faArrowToRight} />
            </StyledButtonLink>
          </Link>
        </>
      )}
    </StyledPagination>
  );
};

export default BlogPagination;
